import { bounce } from "@core-animations/element-animations";
import { AnimationConfig } from "@core-controls/models/animation-config";

export const BADGE_ALERT_ANIMATION_CONFIG: AnimationConfig = {
    repeatTimes: 3,
    animations: bounce()
};